import { useLazyQuery } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { GUEST_AIR_PROFILE } from '../queries';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return { guestAirProfile: bffResponse };
}

export default function useGuestAirProfile(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useLazyQuery(GUEST_AIR_PROFILE, options);
  const [restExecute, restState] = useAsyncCall(({ variables: { input } = {} } = {}) => {
    const { bookingId, correlationID, guestIds, locators } = input ?? {};
    return restRequest({
      method: 'POST',
      path: '/air-api/v1/profile/guest',
      body: { bookingId, correlationID, guestIds, locators },
    }).then(toGraphqlShape);
  }, options);

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
